import { Avatar, Box, Grid, Typography } from '@mui/material';
import { CoinsCounterProps, UserCounters, UserDetail } from '../types';

import React from 'react';
import UserBannerScores from './user-banner-scores';
import ProfileImageBlur from './profileImageBlur';

interface UserAvatarInfoProps {
  userDetail: UserDetail | null;
  userCounters: UserCounters | null;
  coinsData: CoinsCounterProps | null;
  isMobile: Boolean | null;
}

const UserAvatarInfo: React.FC<UserAvatarInfoProps> = ({ userDetail, userCounters, coinsData, isMobile }) => {
  return (
    <Grid container alignItems="flex-start" justifyContent={isMobile ? 'center' : 'flex-start'}>
      <Grid item xs={12} md={2} display="flex" justifyContent="center">
        <Box style={{ border: '4px solid White', borderRadius: '50%' }}>
          <ProfileImageBlur
            defaultAvatar={userDetail && userDetail.defaultAvatar}
            imgHeight={'142px'}
            imgWidth={'142px'}
            uid={userDetail && userDetail.uid}
            avatar={userDetail && userDetail.avatar}
          />
        </Box>
      </Grid>

      <Grid item xs={12} md={6} p={1} sx={{ fontFamily: 'Baloo2' }}>
        <Typography variant="h5" align={isMobile ? 'center' : 'inherit'} sx={{ fontWeight: '800', fontSize: '36px' }}>
          {userDetail?.firstname || 'Anonymous'}
        </Typography>
        <Typography variant="h5" align={isMobile ? 'center' : 'inherit'} sx={{ fontWeight: '500', fontSize: '16px' }}>
          {`@${userDetail?.handle}` || 'Anonymous'}
        </Typography>
        <Typography
          variant="body1"
          align={isMobile ? 'center' : 'inherit'}
          pt={1}
          sx={{ fontWeight: '500', fontSize: '18px', padding: '10px 0' }}>
          {userDetail?.bio}
        </Typography>
      </Grid>

      <Grid item xs={12} md={4}>
        <UserBannerScores userCounters={userCounters} isMobile={isMobile} coinsData={coinsData} />
      </Grid>
    </Grid>
  );
};

export default UserAvatarInfo;
